module.exports = __webpack_public_path__ + "static/media/info.ff7a650f.svg";